import React, { Component, ReactNode } from "react";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { FilterX, Plus } from "lucide-react";

interface DataTableToolbarProps {
    onClear: () => void;
    /** When true, shows the "Clear filters" link. Passed by ExtendedDataTable. */
    hasActiveFilters?: boolean;
    addLabel?: string;
    onAdd?: () => void;
    showAdd?: boolean;
    actions?: ReactNode;
    /** Column selector injected automatically by ExtendedDataTable. */
    columnSelector?: ReactNode;
    className?: string;
}

/**
 * DataTableToolbar — compact right-aligned toolbar for DataTable headers.
 * "Clear filters" only appears when filters are active.
 * When no filters and no add button, renders nothing (no empty row).
 */
export default class DataTableToolbar extends Component<DataTableToolbarProps> {
    render() {
        const { onClear, hasActiveFilters = false, addLabel, onAdd, showAdd = true, actions, columnSelector, className } = this.props;

        const hasAddButton = addLabel && onAdd && showAdd;
        const hasContent = hasActiveFilters || hasAddButton || actions || columnSelector;

        // Don't render an empty toolbar row
        if (!hasContent) return null;

        return (
            <span className={classNames("flex justify-end items-center gap-3 px-4 py-3", className)}>
                {hasActiveFilters && (
                    <button
                        type="button"
                        onClick={onClear}
                        className="inline-flex items-center gap-1.5 text-xs text-neutral-500 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                    >
                        <FilterX size={14} />
                        <span>Clear filters</span>
                    </button>
                )}
                {actions}
                {columnSelector}
                {hasAddButton && (
                    <Button
                        label={addLabel}
                        icon={<Plus size={16} />}
                        onClick={onAdd}
                    />
                )}
            </span>
        );
    }
}
